export class History {
    public past: any[];
    public future: any[];
}

export class StateHistory {
    public history: History;
}

export const initialStateHistory: StateHistory = {
    history: {
        past: [],
        future: []
    }
};